"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const Tooltip_1 = __importDefault(require("../../components/Tooltip/Tooltip"));
const useIsOverflowing_1 = __importDefault(require("../../hooks/useIsOverflowing"));
const useMergeRefs_1 = __importDefault(require("../../hooks/useMergeRefs"));
require("./TextWithHighlight.scss");
const getTextPart = (text, key, shouldHighlight, wrappingTextTag = "em", wrappingElementClassName) => {
    const WrappingElement = wrappingTextTag;
    if (shouldHighlight) {
        return ((0, jsx_runtime_1.jsx)(WrappingElement, Object.assign({ className: (0, classnames_1.default)("highlight-text", wrappingElementClassName) }, { children: text }), key));
    }
    return (0, jsx_runtime_1.jsx)("span", { children: text }, key);
};
const TextWithHighlight = (0, react_1.forwardRef)(({ className, id, text = "", highlightTerm, limit, useEllipsis = true, linesToClamp = 3, ignoreCase = true, allowTermSplit = true, nonEllipsisTooltip, tooltipPosition, wrappingTextTag = "em", wrappingElementClassName }, ref) => {
    const componentRef = (0, react_1.useRef)(null);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    const textWithHighlights = (0, react_1.useMemo)(() => {
        if (!text || !highlightTerm || limit === 0)
            return text;
        let finalTerm = highlightTerm;
        if (allowTermSplit) {
            finalTerm = highlightTerm.split(" ").join("|");
        }
        const tokens = text.split(new RegExp(`(${finalTerm})`, ignoreCase ? "i" : ""));
        const parts = [];
        // Tokens include the term search (in odd indices)
        let highlightTermsCount = 0;
        let key = 0;
        for (let i = 0; i < tokens.length; i++) {
            // skip empty tokens
            if (tokens[i]) {
                // adding highlight part
                const isTermPart = i % 2 === 1;
                const shouldHighlight = isTermPart && (!limit || limit < 0 || highlightTermsCount < limit);
                parts.push(getTextPart(tokens[i], key++, shouldHighlight, wrappingTextTag, wrappingElementClassName));
                if (isTermPart)
                    highlightTermsCount++;
            }
        }
        return parts;
    }, [text, highlightTerm, limit, ignoreCase, allowTermSplit, wrappingTextTag, wrappingElementClassName]);
    const isOverflowing = (0, useIsOverflowing_1.default)({ ref: useEllipsis && componentRef });
    (0, react_1.useLayoutEffect)(() => {
        if (componentRef.current) {
            componentRef.current.style.setProperty("--heading-clamp-lines", linesToClamp);
        }
    }, [componentRef, linesToClamp]);
    const Element = ((0, jsx_runtime_1.jsx)("div", Object.assign({ ref: mergedRef, className: (0, classnames_1.default)("text-with-highlight--wrapper", className, {
            "with-ellipsis": useEllipsis
        }), id: id }, { children: textWithHighlights })));
    if (isOverflowing || nonEllipsisTooltip) {
        const tooltipContent = isOverflowing ? text : nonEllipsisTooltip;
        return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ content: tooltipContent, position: tooltipPosition }, { children: Element })));
    }
    return Element;
});
exports.default = TextWithHighlight;
